export default __webpack_public_path__ + "static/media/Deed of Contract_05.3bf23ffd.jpg";